<template>
    <Modal v-model="visible" width="1300px" title="保单明细" :footer-hide="true" :mask-closable="false" class="my-modal">
        <div class="search-box btn3"
            v-if="detailCode == 'personCheckDetailQuery' || detailCode == 'activeManpowerDetailQuery'">
            <div class="input-item">
                <span class="label">保单号</span>
                <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
            </div>
            <div class="input-item">
                <span class="label">保单状态</span>
                <Select v-model="searchParams.policyStatus" filterable clearable>
                    <Option value="1">已承保</Option>
                    <Option value="-1">已退保</Option>
                    <Option value="0">已终止</Option>
                </Select>
            </div>
            <div class="input-item">
                <span class="label">险种名称</span>
                <Input v-model="searchParams.insuranceName" placeholder="请输入" clearable />
            </div>
            <template v-if="detailCode == 'personCheckDetailQuery'">
                <div class="input-item">
                    <span class="label">出单业务员</span>
                    <Select clearable v-model="searchParams.userId" style="width:256px;" filterable :transfer="true">
                        <Option :value="item.id" v-for="(item, index) in salesmanList" :key="index"
                            :label="item.staffNo + (item.staffNo ? '/' : '') + item.name"></Option>
                    </Select>
                </div>
                <div class="input-item" v-if="userInfo.userType != 4">
                    <span class="label">所属机构/团队</span>
                    <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
                </div>
            </template>
            <div class="btn-item">
                <Button type="primary" @click="searchAjax()">查询</Button>
                <Button type="primary" ghost @click="resetSearch()">重置</Button>
            </div>
        </div>
        <div class="table-box setTable">
            <loading :isShow="listLoading" />
            <Table :columns="columns" :data="tableData">
                <template slot-scope="{ row }" slot="receiptRevisitStatus">
                    <div>{{ RECEIPT_STATUS[row.receiptStatus] }}/{{ VERIFY_STATUS[row.verifyStatus] }}</div>
                </template>
                <template slot-scope="{ row }" slot="userName">
                    <span :class="row.workingState == 1 ? 'opening' : 'close'"></span>{{ row.userName }}
                </template>
                <template slot-scope="{ row }" slot="rateMode">
                    <span>{{ row.rateMode == 1 ? '年度' : '月度' }}</span>
                    <template v-if="row.calculateIndex == 1">R13</template>
                    <template v-else-if="row.calculateIndex == 2">R25 </template>
                    <template v-else-if="row.calculateIndex == 3">R37</template>
                    <template v-else>R49</template>
                </template>
                <template slot-scope="{ row }" slot="action">
                    <span class="table-btn"
                        @click="openDetail({ orgName: row.organizationName, salesmanName: row.agentName, ...row })">保单明细</span>
                </template>
                <template slot-scope="{ row }" slot="action_1">
                    <span class="table-btn"
                        @click="openDetail({ orgName: row.organizationName, salesmanName: row.agentName, ...row })">详情</span>
                    <span class="table-btn"
                        @click="openDetail({ orgName: row.organizationName, salesmanName: row.agentName, ...row })">导出</span>
                </template>
            </Table>
            <Page :total="total" :current.sync="pageNum" :page-size="pageSize" show-total @on-change="getList"
                style="text-align: center" />
        </div>
    </Modal>
</template>

<script>
import { mapState } from "vuex";
import { pageTool } from '@/api/mixins';
import selectTree from '@/components/system/selectTree3';
export default {
    mixins: [pageTool],
    components: {
        selectTree
    },
    computed: {
        ...mapState(["userInfo"]),
    },
    data() {
        return {
            columns: [],
            searchParams: {},
            visible: false,
            loading: false,
            detailCode: '',
            salesmanList: []
        };
    },
    created() { },
    methods: {
        // 转化参数
        setListParams(params) {
            delete params.applyOrgId;
        },
        // 组织选择
        selectTreeChange(data) {
            this.searchParams.userId = '';
            if (data.nodeType == 1) {//机构
                this.searchParams.orgId = data.id;
                this.searchParams.groupId = "";
            } else if (data.nodeType == 2) {//团队
                this.searchParams.orgId = "";
                this.searchParams.groupId = data.id;
            } else {
                this.searchParams.orgId = "";
                this.searchParams.groupId = "";
            }
        },
        // 通过机构获取业务员
        getOrganizationUser() {
            this.$http({
                url: `/buz/userBase/getByOrgIds`,
                type: "POST",
                data: {
                    orgaList: []
                }
            }).then((res) => {
                this.salesmanList = res.data;
            })
        },
        open({ columns, params, detailCode }) {
            this.detailCode = detailCode;
            this.getOrganizationUser(null);
            this.searchParams = {}
            this.visible = true;
            this.columns = columns;
            this.searchParams = {
                ...this.searchParams,
                ...params
            }
            this.initListAjax('/buz/userPromotionRecord/queryDetail');
        }
    }
};
</script>
<style lang="scss" scoped>
.my-modal {

    .btn-add {
        cursor: pointer;
        color: #236DFF;
        margin-left: 10px;
    }

    /deep/ {
        .ivu-checkbox-inner {
            top: -1px;
        }

        .ivu-checkbox-group-item {
            width: 25%;
            margin-right: 0;
        }
    }
}

.tab-box {
    position: relative;
    margin-bottom: 10px;

    .tab-name {
        position: absolute;
        left: 0;
        top: 11px;
        z-index: 1;
        font-size: 14px;
        font-weight: bold;
    }

    /deep/ {
        .ivu-tabs-nav {
            padding-left: 120px;
        }
    }
}
</style>
